import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ZoomControlComponent } from 'src/app/shared/components/ui/zoom-control/zoom-control.component';
import { ZoomableDirective } from 'src/app/shared/directives/zoomable.directive';
import { WhiteboardPartComponent } from 'src/app/shared/components/whiteboard/whiteboard-part.component';

export interface WhiteboardDialogData {
  drawHistory: any[];
  postits: any[];
  title: string;
}

@Component({
  selector: 'app-whiteboard-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    ZoomControlComponent,
    ZoomableDirective,
    WhiteboardPartComponent
  ],
  template: `
    <div class="whiteboard-dialog-container">
      <div
        #zoom="appZoomable"
        appZoomable
        [minScale]="0.3"
        [maxScale]="5.0"
        class="whiteboard-dialog-body"
        [class.grabbing]="zoom.isDragging()"
      >
        <app-zoom-control
          class="zoom-toolbar"
          [(zoomScale)]="zoom.zoomScale"
          [minScale]="0.3"
          [maxScale]="5.0"
          [showClose]="true"
          (close)="closeDialog()"
          (reset)="zoom.resetZoom()"
          (click)="$event.stopPropagation()"
        />

        <div
          class="whiteboard-render-area"
          style="width: 100%; height: 100%;"
        >
          <app-whiteboard-part
            [color]="'#333333'"
            [size]="5"
            [boardID]="boardID"
            [zoomScale]="zoom.zoomScale()"
            [panX]="zoom.panX()"
            [panY]="zoom.panY()"
            [drawHistory]="data.drawHistory"
            [postits]="data.postits"
            [renderPostItsOnCanvas]="true"
            style="pointer-events: none;"
          />
        </div>
      </div>
    </div>
  `,
  styles: [`
    .whiteboard-dialog-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      background: #ffffff;
    }

    .whiteboard-dialog-body {
      flex: 1;
      position: relative;
      overflow: hidden;
      cursor: grab;
      user-select: none;
      display: flex;
      justify-content: center;
      align-items: center;

      &.grabbing {
        cursor: grabbing;
      }
    }

    .whiteboard-render-area {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }

    .zoom-toolbar {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 10;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhiteboardDialogComponent {
  data: WhiteboardDialogData = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<WhiteboardDialogComponent>);
  boardID = Math.random();

  closeDialog(): void {
    this.dialogRef.close();
  }
}
